import { useState, useEffect } from 'react';
import { Container, SwitchContainer, Input, Slider, Button } from './styles';

/**
 * Componente para controle responsável pelo estado 
 * @param {boolean} State estado inicial da aplicação
 * @param {Function} onChange muda o estado da aplicação
 * @param {boolean} disabled indica se o estado é fixo (default: false)
 * @param {boolean} isNewValue indica se o valor é novo inserido pelo usuário
 * @returns {ReactComponentElement} 
 */
const State = ({State, onChange, disabled, isNewValue}) => {
    // Exemplo de função para ser utilizada onChange
    // const currentState = useRef(false)
    // const onChange = (newState)=>{
    //     currentState.current = newState;
    // }

    const [isChecked, setIsChecked] = useState(State);

    useEffect(() => {
        setIsChecked(State)
    }, [State]);

    const handleToggle = () => {
        // confirmar comando
        onChange(!isChecked)
        setIsChecked(!isChecked);
    };

    return (
        <Container>
            <SwitchContainer>
                <Input type="checkbox" checked={isChecked} disabled={disabled} onChange={() => handleToggle()} />
                <Slider checked={isChecked}/>
                <Button checked={isChecked} isNewValue={isNewValue}>
                    {isChecked ? 'L' : 'D'}
                </Button>
            </SwitchContainer>
        </Container>
    );
}

export default State;